import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async searchPromoCodes(context, { giftId, params }) {
      const response = await http.get(`gift/${giftId}/promo-code/${requestUrlFunction(params)}`)

      return response
    },
    async createPromoCode(context, { giftId, promoCode }) {
      const response = await http.post(`gift/${giftId}/promo-code`, {
        code: promoCode.code,
      })

      return response
    },
    async deletePromoCode(context, { giftId, promoCodeId }) {
      const response = await http.delete(`gift/${giftId}/promo-code/${promoCodeId}`)

      return response
    },
    async importPromoCodes(context, { giftId, files }) {
      const formData = new FormData()
      formData.append('file', files[0])

      const response = await http.post(`gift/${giftId}/promo-code/import`, formData)

      return response
    },
  },
}
